"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var typedAction = exports.typedAction = function typedAction(type, fn) {
    var result = fn ? function () {
        return _extends({}, fn.apply(undefined, arguments), { type: type });
    } : function () {
        return { type: type };
    };
    result.TYPE = type;
    return result;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-sac/lib/typed-action.js
// module id = 1481
// module chunks = 2